import Vue from 'vue'
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/index.css'
import 'normalize.css/normalize.css'
import '@/styles/index.scss'

import App from './App'
import store from './store'
import router from './router'
import globalRouter from '@/utils/routerJump'
import './filters'
import '@/permission'
import '@/icons'

Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$globalRouter = globalRouter

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
